<div
  class="d-flex justify-content-between align-items-center globalborder-btm-header pb-3 pt-2 px-3">
  <div class="d-flex justify-content-between align-items-center gap-3">
    <h2 class="mb-0">Commission Paid Total</h2>
  </div>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <p-button
        label="Export Excel"
        variant="outlined"
        icon="pi pi-cloud-upload"
        severity="secondary"
        (click)="exportExcelFile()"
        class="fullwdth secondary-btn" />

      <p-button label=" Clear Filters" (click)="clearTable(dt)" />

      <span class="cross-border" (click)="onCloseModalEvent()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>
</div>

<div class="p-wrapper-custom">
  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="commissionsPaidTotalList"
    stripedRows
    scrollHeight="calc(100vh - 265px)"
    responsiveLayout="scroll"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    styleClass="p-datatable-customers p-head-pad"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="commissionsPaidTotalList.length >= 20"
    [autoLayout]="true"
    [resizableColumns]="true">
    <ng-template pTemplate="caption">
      <div class="d-flex align-items-center">
        <ng-container *ngIf="commissionsPaidTotalList?.length">
          <div
            class="form-group has-float-label d-flex align-items-center gap-2 me-2 px-2">
            <label class="form-label" for="total">Total</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              class="form-control filter me-2 text-end"
              type="text"
              [value]="total | number: '1.2-2'"
              disabled />
          </div>
        </ng-container>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Date">
          Date <p-sortIcon field="Date"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="Date"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="CategoryID">
          Category ID <p-sortIcon field="CategoryID"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="CategoryID"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="ProjectName">
          BC Name <p-sortIcon field="ProjectName"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="ProjectName"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="Description">
          Description <p-sortIcon field="Description"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="Description"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="AmountinTransactionCurrency">
          Amount In Transaction Currency
          <p-sortIcon field="AmountinTransactionCurrency"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="AmountinTransactionCurrency"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="CreatedDateTime">
          Created Date and Time
          <p-sortIcon field="CreatedDateTime"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="CreatedDateTime"
            display="menu"></p-columnFilter>
        </th>
        <th pSortableColumn="CreatedBy">
          Created By <p-sortIcon field="CreatedBy"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="CreatedBy"
            display="menu"></p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-commissionPaidTotal
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="commissionPaidTotal"
        [pSelectableRowIndex]="rowIndex">
        <td>{{ commissionPaidTotal.Date | date: "yyyy-MM-dd" }}</td>
        <td>{{ commissionPaidTotal.CategoryID }}</td>
        <td>{{ commissionPaidTotal.ProjectName }}</td>
        <td>{{ commissionPaidTotal.Description }}</td>
        <td class="align-right">
          {{
            commissionPaidTotal.AmountinTransactionCurrency | number: "1.2-2"
          }}
        </td>
        <td>
          <span *ngIf="commissionPaidTotal?.CreatedDateTime | hidedynamicsdate">
            {{ commissionPaidTotal.CreatedDateTime | date: "yyyy-MM-dd" }}
          </span>
        </td>
        <td>{{ commissionPaidTotal.CreatedBy }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No Data Found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
